import DataLoader from 'dataloader'

export class Loader {
  public static get(
    func: (...args) => any,
    options: any = {
      cacheKeyFn: ([id]) => id
    }
  ): DataLoader<any, any> {
    const loader = new DataLoader(ids => {
      return func(ids)
    }, options)
    loader.load = loader.load.bind(loader)
    return loader
  }
}
